//reducer
import {
  GET_SYSTEM_MODULE_LIST,
  GET_SYSTEM_MODULE_LIST_SUCCESS,
  GET_SYSTEM_MODULE_LIST_FAIL,
  GET_SYSTEM_MODULE_DATA,
  GET_SYSTEM_MODULE_DATA_SUCCESS,
  GET_SYSTEM_MODULE_DATA_FAIL,
  ACTIVATE_SYSTEM_MODULE,
  ACTIVATE_SYSTEM_MODULE_SUCCESS,
  ACTIVATE_SYSTEM_MODULE_FAIL,
  DEACTIVATE_SYSTEM_MODULE,
  DEACTIVATE_SYSTEM_MODULE_SUCCESS,
  DEACTIVATE_SYSTEM_MODULE_FAIL,
  CREATE_SYSTEM_MODULE,
  CREATE_SYSTEM_MODULE_SUCCESS,
  CREATE_SYSTEM_MODULE_FAIL,
  UPDATE_SYSTEM_MODULE,
  UPDATE_SYSTEM_MODULE_SUCCESS,
  UPDATE_SYSTEM_MODULE_FAIL,
  DELETE_SYSTEM_MODULE,
  DELETE_SYSTEM_MODULE_SUCCESS,
  DELETE_SYSTEM_MODULE_FAIL,
} from "./actionType";

const INIT_STATE = {
  systemModuleList: [],
  systemModuleListLoading: false,
  systemModuleListError: {},

  systemModuleData: {},
  systemModuleDataLoading: false,
  systemModuleDataError: {},

  activateSystemModuleSuccess: [],
  activateSystemModuleLoading: false,
  activateSystemModuleError: {},

  deactivateSystemModuleSuccess: [],
  deactivateSystemModuleLoading: false,
  deactivateSystemModuleError: {},

  createSystemModuleSuccess: [],
  createSystemModuleLoading: false,
  createSystemModuleError: {},

  updateSystemModuleSuccess: [],
  updateSystemModuleLoading: false,
  updateSystemModuleError: {},

  deleteSystemModuleSuccess: [],
  deleteSystemModuleLoading: false,
  deleteSystemModuleError: {},
};

const SystemModule = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List
    case GET_SYSTEM_MODULE_LIST:
      return {
        ...state,
        systemModuleListLoading: true,
      };
    case GET_SYSTEM_MODULE_LIST_SUCCESS:
      return {
        ...state,
        systemModuleList: action.payload,
        systemModuleListLoading: false,
      };
    case GET_SYSTEM_MODULE_LIST_FAIL:
      return {
        ...state,
        systemModuleListError: action.payload,
        systemModuleListLoading: false,
      };

    // Data
    case GET_SYSTEM_MODULE_DATA:
      return {
        ...state,
        systemModuleDataLoading: true,
      };
    case GET_SYSTEM_MODULE_DATA_SUCCESS:
      return {
        ...state,
        systemModuleData: action.payload,
        systemModuleDataLoading: false,
      };
    case GET_SYSTEM_MODULE_DATA_FAIL:
      return {
        ...state,
        systemModuleDataError: action.payload,
        systemModuleDataLoading: false,
      };

    // Activate
    case ACTIVATE_SYSTEM_MODULE:
      return {
        ...state,
        activateSystemModuleLoading: true,
      };
    case ACTIVATE_SYSTEM_MODULE_SUCCESS:
      return {
        ...state,
        activateSystemModuleSuccess: action.payload,
        activateSystemModuleLoading: false,
      };
    case ACTIVATE_SYSTEM_MODULE_FAIL:
      return {
        ...state,
        activateSystemModuleError: action.payload,
        activateSystemModuleLoading: false,
      };

    // Deactivate
    case DEACTIVATE_SYSTEM_MODULE:
      return {
        ...state,
        deactivateSystemModuleLoading: true,
      };
    case DEACTIVATE_SYSTEM_MODULE_SUCCESS:
      return {
        ...state,
        deactivateSystemModuleSuccess: action.payload,
        deactivateSystemModuleLoading: false,
      };
    case DEACTIVATE_SYSTEM_MODULE_FAIL:
      return {
        ...state,
        deactivateSystemModuleError: action.payload,
        deactivateSystemModuleLoading: false,
      };

    // Create
    case CREATE_SYSTEM_MODULE:
      return {
        ...state,
        createSystemModuleLoading: true,
      };
    case CREATE_SYSTEM_MODULE_SUCCESS:
      return {
        ...state,
        createSystemModuleSuccess: action.payload,
        createSystemModuleLoading: false,
      };
    case CREATE_SYSTEM_MODULE_FAIL:
      return {
        ...state,
        createSystemModuleError: action.payload,
        createSystemModuleLoading: false,
      };

    // Update
    case UPDATE_SYSTEM_MODULE:
      return {
        ...state,
        updateSystemModuleLoading: true,
      };
    case UPDATE_SYSTEM_MODULE_SUCCESS:
      return {
        ...state,
        updateSystemModuleSuccess: action.payload,
        updateSystemModuleLoading: false,
      };
    case UPDATE_SYSTEM_MODULE_FAIL:
      return {
        ...state,
        updateSystemModuleError: action.payload,
        updateSystemModuleLoading: false,
      };

    // Delete
    case DELETE_SYSTEM_MODULE:
      return {
        ...state,
        deleteSystemModuleLoading: true,
      };
    case DELETE_SYSTEM_MODULE_SUCCESS:
      return {
        ...state,
        deleteSystemModuleSuccess: action.payload,
        deleteSystemModuleLoading: false,
      };
    case DELETE_SYSTEM_MODULE_FAIL:
      return {
        ...state,
        deleteSystemModuleError: action.payload,
        deleteSystemModuleLoading: false,
      };

    default:
      return state;
  }
};

export default SystemModule;
